import React from 'react';
import { RadioButtonUnchecked, CheckCircle, PlayArrow } from '@mui/icons-material';
import axios from '../../../../api/axios';

export function useQuestionsPageHandlers({
  navigate,
  selectedCourse,
  setQuestions,
  refetchData,
  setSelectedQuestion,
  setStudentsDialogOpen,
  setQuestionStudents,
  setLoadingStudents,
}) {
  const handleViewQuestionStudents = React.useCallback(
    async (e, question) => {
      e.stopPropagation();
      setSelectedQuestion(question);
      setStudentsDialogOpen(true);
      setLoadingStudents(true);
      setQuestionStudents([]);

      try {
        let questionId;
        let endpoint;

        if (question.isNotebookExample) {
          const rawId = question.id || question._id;
          if (!rawId) throw new Error('Question ID is undefined');
          if (typeof rawId === 'string' && rawId.startsWith('notebook_')) {
            questionId = rawId;
          } else {
            const numericId =
              typeof rawId === 'string' ? rawId.replace('notebook_', '') : String(rawId);
            questionId = `notebook_${numericId}`;
          }
          endpoint = `/teacher/questions/${questionId}/students`;
        } else {
          questionId = question._id || question.id;
          if (!questionId) throw new Error('Question ID is undefined');
          endpoint = `/teacher/questions/${questionId}/students`;
        }

        const response = await axios.get(endpoint, {
          params: { courseTemplateId: selectedCourse?.id },
        });
        setQuestionStudents(response.data);
      } catch (error) {
        console.error('Error fetching students for question:', error);
        setQuestionStudents([]);
      } finally {
        setLoadingStudents(false);
      }
    },
    [
      selectedCourse?.id,
      setSelectedQuestion,
      setStudentsDialogOpen,
      setQuestionStudents,
      setLoadingStudents,
    ]
  );

  const handleDeleteQuestion = React.useCallback(
    async (question) => {
      if (!window.confirm('确定要删除这道题目吗？')) return;
      try {
        if (question.isNotebookExample) {
          await axios.delete(`/notebook-examples/${question.id.replace('notebook_', '')}`);
        } else {
          await axios.delete(`/questions/${question._id || question.id}`);
        }
        refetchData();
      } catch (error) {
        console.error('Error deleting question:', error);
        alert('删除失败：' + (error.response?.data?.error || error.message));
      }
    },
    [refetchData]
  );

  const getStatusIcon = React.useCallback((userStatus) => {
    if (!userStatus) return <RadioButtonUnchecked color="disabled" />;
    if (userStatus.status === 'passed') return <CheckCircle color="success" />;
    return <PlayArrow color="primary" />;
  }, []);

  const handleCategoryChange = React.useCallback(
    (cat) => {
      if (cat === 'all') {
        navigate('/questions');
      } else {
        navigate(`/questions/category/${encodeURIComponent(cat)}`);
      }
    },
    [navigate]
  );

  return {
    handleViewQuestionStudents,
    handleDeleteQuestion,
    getStatusIcon,
    handleCategoryChange,
  };
}
